import { sharedRoutes } from 'acscp/components/sharedRoutes';
import React from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedIntlProvider } from 'acscp/components/intl/translate';
import { AppState } from 'acscp/store';
import * as Redux from 'redux';
import {Router, Switch} from 'react-router-dom';
import { NotFound, ServerError, UnsharedLink } from './pages/errorPage';
import { SharingTokenAwareRoute } from 'acscp/components/sharingTokenAwareRoute';
import history from 'acscp/store/history';
import { HomePage } from 'acscp/components/pages/HomePage';

interface RootProps {
    store: Redux.Store<AppState>;
}

export default class Root extends React.Component<RootProps, {}> {
    render(): JSX.Element {
        return (
            <Provider store={this.props.store}>
                <ConnectedIntlProvider>
                    <Router history={history}>
                        <Switch>
                            {sharedRoutes}
                            <Route path="/error" exact={true} component={ServerError} />
                            <Route path="/deactivated-link" exact={true} component={UnsharedLink} />
                            <SharingTokenAwareRoute path="/" exact={true} component={HomePage} />
                            <Route component={NotFound} />
                        </Switch>
                    </Router>
                </ConnectedIntlProvider>
            </Provider>
        );
    }
}
